import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AppAgendaProvider } from './context/AppAgendaContext';
import IndexPac from './pages/IndexPac';
import SeleccionaTipoHora from './pages/SeleccionaTipoHora';
import SeleccionaEspSuc from './pages/SeleccionaEspSuc';
import SeleccionaProfSuc from './pages/SeleccionaProfSuc';
import SeleccionaFecHora from './pages/SeleccionaFecHora';
import ConfirmaFonoMail from './pages/ConfirmaFonoMail';
import ConfirmaPaciente from './pages/ConfirmaPaciente';
import ConfirmaAgendamiento from './pages/ConfirmaAgendamiento';
import DebugPanel from './components/DebugPanel'; // ✅ Importación

function App() {
  return (
    <AppAgendaProvider>
      <Router>
        <Routes>
          <Route path="/" element={<IndexPac />} />
          <Route path="/IndexPac" element={<IndexPac />} />
          <Route path="/SeleccionaTipoHora" element={<SeleccionaTipoHora />} />
          <Route path="/SeleccionaEspSuc" element={<SeleccionaEspSuc />} />
          <Route path="/SeleccionaProfSuc" element={<SeleccionaProfSuc />} />
          <Route path="/SeleccionaFecHora" element={<SeleccionaFecHora />} />
          <Route path="/ConfirmaFonoMail" element={<ConfirmaFonoMail />} />
          <Route path="/ConfirmaPaciente" element={<ConfirmaPaciente />} />
          <Route path="/ConfirmaAgendamiento" element={<ConfirmaAgendamiento />} />
        </Routes>
      </Router>

      {/* Mostrar solo en entorno de desarrollo */}
      {process.env.NODE_ENV !== 'production' && <DebugPanel />}
    </AppAgendaProvider>
  );
}

export default App;
